// Redimensiona y comprime una imagen ANTES de convertirla a base64, vía
// canvas — sin esto, una foto de celular moderna (12-48MP) se guarda tal
// cual en Mongo como base64, varios MB por foto. Encontrado real: un
// catálogo de referencia armado fuera de la app pesaba 55MB en un solo
// archivo por este mismo motivo (fotos sin comprimir). Con maxAncho=1600 y
// calidad=0.82 una foto de celular queda nítida en pantalla pero baja a
// 150-400KB típicamente.
// formato "image/jpeg" (por defecto, para fotos) o "image/png" — usar PNG
// para logos/íconos que puedan tener fondo transparente, porque JPEG no
// soporta transparencia y el canvas le pinta fondo negro por debajo sin
// avisar.
export function comprimirImagen(file, { maxAncho = 1600, calidad = 0.82, formato = "image/jpeg" } = {}) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onerror = () => reject(new Error("No se pudo leer el archivo"));
    lector.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("No se pudo leer la imagen"));
      img.onload = () => {
        const escala = Math.min(1, maxAncho / img.width);
        const ancho = Math.round(img.width * escala);
        const alto = Math.round(img.height * escala);
        const canvas = document.createElement("canvas");
        canvas.width = ancho;
        canvas.height = alto;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, ancho, alto);
        resolve(canvas.toDataURL(formato, formato === "image/png" ? undefined : calidad));
      };
      img.src = lector.result;
    };
    lector.readAsDataURL(file);
  });
}
